import { GrainUsageTypeEnum } from '@/common/constants';
import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

export const PartiesSchema = yup.object().shape({
  party_number: yup.mixed().when('$grainUsageType', {
    is: (grainUsageType: string) => grainUsageType === GrainUsageTypeEnum.SEED,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional().nullable(),
  }),
  place_name: yup.string().when('$grainUsageType', {
    is: (grainUsageType: string) => grainUsageType === GrainUsageTypeEnum.GOODS,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),
  plant_id: yup.string().required(messages.required),
  place_number: yup.string().required(messages.required),
  capacity: yup.number().required(messages.required),
  crop_type_id: yup.string().required(messages.required),
  crop_generation_id: yup.string().when('$grainUsageType', {
    is: (grainUsageType: string) => grainUsageType === GrainUsageTypeEnum.SEED,
    then: () => yup.string().required(messages.required),
    otherwise: () => yup.string().optional(),
  }),
  storage_type: yup.string(),
  class: yup.number().required(messages.required),
});
